module.exports = __webpack_public_path__ + "img/iphone-map-UK-en.0ab0f3cf.png";